const currencyFormat = currency => number =>
    new Number(number).toLocaleString(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

const titleCallback = currency => context => {
    const rawValue = context[0].label;
    const formatted = currencyFormat(currency)(rawValue);
    return formatted;
};

const currencyConfig = ({ currency }) => {
    return {
        scales: {
            x: {
                beginAtZero: true,
                type: 'linear',
                ticks: {
                    callback: currencyFormat(currency),
                },
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    title: titleCallback(currency),
                },
            },
        },
    };
};

export default currencyConfig;
